import {ImportModel} from "./ImportModel";
import {Asset} from "../../entities/Asset";
import {AssetService} from "../../services/AssetService";

export class AssetImportModel extends ImportModel<Asset>  {
    static $inject = ['$q','AssetService'];
    name:string = "test";
    importType:string = "Asset";

    constructor($q:ng.IQService, public assetService:AssetService){
        super($q,assetService);
    }
    getRoute(nextAction:string):string{
        return "admin.assetimport."+nextAction;
    }
}
